export function generateDocumentUrl(
  baseUrl: string,
  document: string,
  preferredLanguage: string
) {
  const legalBaseUrl = new URL(baseUrl);
  return new URL(
    `${document}.${preferredLanguage}.html`,
    legalBaseUrl
  ).toString();
}
